var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "emd-menu__subsection menu-subitems" }, [
    _c(
      "ul",
      { staticClass: "emd-menu-list" },
      [
        _vm._l(_vm.subitems, function (item, id) {
          return [
            item.showItem
              ? _c(
                  "router-link",
                  {
                    key: id,
                    staticClass: "emd-menu-list__item",
                    class: { _active: item.active },
                    attrs: {
                      to: { name: id },
                      tag: "li",
                      exact: "",
                      "data-testid": "dropdown-sub-menu",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "menu-subitem",
                        on: {
                          click: function ($event) {
                            return _vm.sendEvent(item.label)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t(item.label)) + " ")]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }